export default "/images/spotify.svg?eefab5a9268d3721c294c608709c049e";